export function scrollTop(): void {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
}